import { createFileRoute } from '@tanstack/react-router';
import { common } from '@/features/i18n/common';
import { t } from '@/features/i18n/utils';
import { useState } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { scopePackageChoicesQuery } from '@/features/work-packages/queries';
import { useSetScopeMembership } from '@/features/work-packages/mutations';
import { ScopePackagePicker } from '@/features/work-packages/components/scope-package-picker';
import { Button } from '@/ui/components/button';
import { Form } from '@/ui/components/form';
import { Card } from '@/ui/components/card';
import { H3 } from '@/ui/components/heading';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines',
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(scopePackageChoicesQuery(params.workspaceId)),
  component: RouteComponent,
});

function RouteComponent() {
  const { procurementId } = Route.useParams();
  return <MembershipForm key={procurementId} />;
}

function MembershipForm() {
  const { procurementId, workspaceId } = Route.useParams();
  const { data } = useSuspenseQuery(scopePackageChoicesQuery(workspaceId));
  const [itemIds, setItemIds] = useState(
    () => data.packages.find((pack) => pack.id === procurementId)?.itemIds ?? [],
  );
  const update = useSetScopeMembership(procurementId);

  return (
    <Form
      onFormSubmit={() => update.mutate(itemIds)}
      className="max-w-2xl w-full flex flex-col gap-4"
    >
      <Card className="space-y-4">
        <H3 className="-mt-1">{t({ en: 'Requirements', nb: 'Krav' })}</H3>
        <ScopePackagePicker itemIds={itemIds} onChange={setItemIds} />
      </Card>
      <Button type="submit" pending={update.isPending} className="ml-auto">
        {t(common.save)}
      </Button>
    </Form>
  );
}
